import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import type { EndpointResponse } from '@/types/endpoints';
import type { ApiKey, ApiKeyUpdateRequest } from '@/types/user';
import { utils } from '@/utils';
import type { WriteRequestOptions } from '../requestOptions';

type RequestParams = {
  keyId: string;
  keyData: ApiKeyUpdateRequest;
};

export const updateApiKey = async (
  scope: RequestScope,
  { keyId, keyData }: RequestParams,
  options: WriteRequestOptions
): Promise<EndpointResponse<ApiKey>> => {
  try {
    const response = await scopedApi(scope).put<EndpointResponse<ApiKey>>(`/organization/client/${keyId}`, keyData, options);
    return response.data;
  } catch (error) {
    return utils.error.handleAxiosError(error);
  }
};
